import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const updateActions = createActionGroup({
    source: 'Update',
    events: {
        // Look for a newer bundle — dispatched on shell init and on every device unlock.
        Check: emptyProps(),
        // A newer bundle exists and its zip transfer has started.
        Downloading: emptyProps(),
        // A newer bundle is downloaded; carries the bundle id the bridge applies on the next lock
        // or session reset (logout / user switch), plus its version so a later check can skip it.
        Downloaded: props<{ payload: { id: string; version: string } }>(),
        // A download that started and broke — bad zip, a dead transfer. Surfaced as a toast and
        // retried on the next unlock. A check that never reached latest.json ends silently.
        Failed: emptyProps(),
        // Apply the pending bundle now — the manual reload button on the profile page.
        Apply: emptyProps(),
        // Dispatched on shell init — re-raise a lock gate that an update reload dropped.
        'Restore Lock': emptyProps(),
    },
});
